import { render, staticRenderFns } from "./SalvaModifiche.vue?vue&type=template&id=49fd97e0&scoped=true"
import script from "./SalvaModifiche.vue?vue&type=script&lang=js"
export * from "./SalvaModifiche.vue?vue&type=script&lang=js"
import style0 from "./SalvaModifiche.vue?vue&type=style&index=0&id=49fd97e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49fd97e0",
  null
  
)

export default component.exports